//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var that;
export default {
  data: function data() {
    that = this;
    return {
      show: true,
      top: 0,
      left: 0,
      content: '',
      viewport: {
        width: 0,
        height: 0
      }
    };
  },
  directives: {
    draggable: {
      bind: function bind(el) {
        var offsetX, offsetY, currentX, currentY, rect;

        el.onmousedown = function (e) {
          rect = el.getBoundingClientRect();
          offsetX = e.clientX - rect.left;
          offsetY = e.clientY - rect.top + 100;
          currentX = el.style.left || 0;
          currentY = el.style.top || 0;

          document.onmousemove = function (e) {
            that.left = that.clamp(e.clientX - offsetX, 0, that.viewport.width - rect.width);
            that.top = that.clamp(e.clientY - offsetY, 0, that.viewport.height - rect.height);
          };

          document.onmouseup = function () {
            document.onmousemove = null;
            document.onmouseup = null;
          };

          e.preventDefault();
        };
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.content = window.localStorage.getItem('tenantRemark') && window.localStorage.getItem('tenantRemark') != 'null' ? window.localStorage.getItem('tenantRemark') : '永春县地处福建省东南部、晋江东溪上游，东邻仙游县，南接南安市、安溪县，西连漳平市，北与德化、大田交界，面积1456.87平方千米。辖区共有22个乡镇，一个省级工业园区，全县共有水泥，鞋服，砖瓦等行业。生猪规模养殖企业34家，养殖规模约5万头。';
    this.$nextTick(function () {
      _this.viewport.width = _this.$refs.parentBox.clientWidth;
      _this.viewport.height = _this.$refs.parentBox.clientHeight; // 初始位置居中

      _this.top = _this.viewport.height - _this.$refs.draggableBox.clientHeight;
      _this.left = (_this.viewport.width - 570) / 2;
    });
  },
  methods: {
    openBox: function openBox() {
      this.show = !this.show;
    },
    clamp: function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }
  }
};